const ParentInventoryStatus = {
  New: 1,
  Notified: 2,
  Canceled: 3,
  Completed: 4,
};

export default ParentInventoryStatus;
